function joinClassNames(...classNames) {
  return classNames.filter(Boolean).join(' ');
}

export default function CatRunningOutlineFrame({
  children,
  className = '',
  contentClassName = '',
  lineClassName = 'shadow-[0_0_0_1px_rgba(255,255,255,0.95)]',
  fillClassName = '',
  lineWidth = 2,
  cornerGap = 5,
  contentInset = 2,
  contentAbsolute = false,
}) {
  return (
    <div className={joinClassNames('relative', className)}>
      <span
        className={joinClassNames('absolute top-0 bg-white', lineClassName)}
        style={{ left: cornerGap, right: cornerGap, height: lineWidth }}
      />
      <span
        className={joinClassNames('absolute bottom-0 bg-white', lineClassName)}
        style={{ left: cornerGap, right: cornerGap, height: lineWidth }}
      />
      <span
        className={joinClassNames('absolute left-0 bg-white', lineClassName)}
        style={{ top: cornerGap, bottom: cornerGap, width: lineWidth }}
      />
      <span
        className={joinClassNames('absolute right-0 bg-white', lineClassName)}
        style={{ top: cornerGap, bottom: cornerGap, width: lineWidth }}
      />

      {fillClassName ? (
        <div
          className={joinClassNames('absolute z-0', fillClassName)}
          style={{ top: contentInset, right: contentInset, bottom: contentInset, left: contentInset }}
        />
      ) : null}

      <div
        className={joinClassNames(contentAbsolute ? 'absolute z-[1]' : 'relative z-[1]', contentClassName)}
        style={
          contentAbsolute
            ? { top: contentInset, right: contentInset, bottom: contentInset, left: contentInset }
            : { padding: contentInset }
        }
      >
        {children}
      </div>
    </div>
  );
}
